// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2D2Q9","col":"styles_col__1Cu5k","fulfillmentStatus":"styles_fulfillmentStatus__1_wk9","emailCol":"styles_emailCol__1Zd78"};